import { Image as ImageIcon } from 'lucide-react'
import { cn } from '@/lib/utils'
import { useFileThumbnail } from './galleryThumbnails'

interface FileThumbnailProps {
  file: File
  alt: string
  className?: string
  /** `contain` for the large preview; `cover` for the grid and lists. */
  fit?: 'cover' | 'contain'
}

/** The worker-made thumbnail of a file being uploaded, with a skeleton until it is ready. Never the original file. */
export const FileThumbnail = ({ file, alt, className, fit = 'cover' }: FileThumbnailProps) => {
  const { url, failed } = useFileThumbnail(file)
  if (url) {
    return (
      <img
        src={url}
        alt={alt}
        decoding="async"
        loading="lazy"
        className={cn('h-full w-full', fit === 'cover' ? 'object-cover' : 'object-contain', className)}
      />
    )
  }
  return (
    <div
      role="img"
      aria-label={alt}
      className={cn('flex h-full w-full items-center justify-center bg-gray-100', !failed && 'animate-pulse', className)}
    >
      <ImageIcon className="h-1/3 max-h-8 w-1/3 max-w-8 text-gray-300" />
    </div>
  )
}
